<div class="flex h-full w-full flex-col">
  <app-toolbox
    [sections]="toolboxSections()"
    [searchConfig]="searchCfg"
    [searchPlaceholder]="searchPlaceholder()"
    [(searchQuery)]="search" />

  @if (newSolverConfigModalIsOpen()) {
    <app-modal
      [config]="newSolverConfigModalConfig"
      (closeModal)="newSolverConfigModalIsOpen.set(false)"
      [title]="newSolverTitle()">
      <app-new-params
        modal-body
        (closeModal)="newSolverConfigModalIsOpen.set(false)"
        (newSolverOutput)="submitNewSolver($event)" />
    </app-modal>
  }
  @if (editSolverConfigModalIsOpen()) {
    <app-modal
      [config]="newSolverConfigModalConfig"
      (closeModal)="editSolverConfigModalIsOpen.set(false)"
      [title]="updateSolverTitle()">
      <app-update-params
        modal-body
        [paramsConfig]="selectedParamConfig()"
        (closeModal)="editSolverConfigModalIsOpen.set(false)"
        (updateParamOutput)="submitUpdateParam($event)" />
    </app-modal>
  }

  @if (deleteMetadataModal().isOpen) {
    <app-modal
      [config]="deleteMetadataModal().config"
      (closeModal)="deleteMetadataModal().isOpen = false"
      [title]="deleteMetadataModal().title()">
      <div modal-body>
        {{ deleteMetadataModal().message() }}
      </div>
    </app-modal>
  }

  <div class="flex h-full min-h-0 flex-1 flex-col">
    <app-table
      [tableId]="'solver-list'"
      [data]="paramsConfigs()"
      [allColumns]="columns()"
      [actions]="actions()"
      [selected]="displayedData()"
      [config]="tableConfig"
      class="rounded-sm" />
  </div>
</div>
